import { configureStore } from '@reduxjs/toolkit';

import { tableSelection } from './tableSelection';

const store = configureStore({
  reducer: {
    tableSelection,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
export default store;
